<template>
    <div class="row no-gutters body">
        <div class="col-12 pb-5 mb-4">
            <div class="row no-gutters">
                <div class="col-12">
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <div class=" no-gutters mt-5 "  >
                        <div class="col-lg-12"> 
                            <div class="row no-gutters">
                                <br />
                            </div>
                            <div class="col-12 pb-5 mb-4" v-if="pageLoder">
                                <img src="../assets/pageloader.svg" class="pageloader" alt="loading">
                            </div>                            
                            <section class="mt-2 pb-4 pb-lg-3 ml-lg-4 mr-lg-4 ml-2 mr-2 main-card" v-else>
                                <div class="container-fluid pl-md-3 pr-md-3 ">
                                    <div class="d-flex ">
                                        <div >  
                                            <img :src="profilePicLink" alt="profilepic"  oncontextmenu="return false" class="rounded-circle profile-border profileimgad" id="profImage">
                                        </div>
                                        <div class="d-lg-flex m-lg-3 m-1">  
                                            <div class="fontsize32  proximanova-semibold black text-capitalize">{{firstname}} {{lastname}}</div>
                                            <div class="fontsize32  proximanova ml-lg-4">we’re unhappy to see you go</div>
                                        </div>                                        
                                    </div>
                                    <div class="fontsize20  proximanova mt-2">Are you sure you dont want to reconsider your account?</div>
                                    <div class="fontsize20  proximanova mt-2">If you no longer intrested in using your account in Worknotion, You will be lose all your below details with Worknotion.</div>
                                    <div class="pt-3 pb-3" >
                                        <hr class="profhoriz">
                                    </div>
                                    <div v-if="profileVideoId !== null || resumeVideoId !== null">
                                        <span class="fontsize32  proximanova">Your <span class="fontsize32  proximanova-semibold"> Video Profile </span>and <span class="fontsize32  proximanova-semibold">Video Resume </span>is <span class="fontsize32  proximanova-semibold">having  more credibility, don’t lose it.</span></span>
                                        <div class="d-flex justify-content-start pt-4">
                                            <div  class="col-lg-4 col-md-6 col-6 col-md-4 p-0 " v-if="profileVideoId !== null">
                                                <div class="card ml-2 mr-2 mb-2 overlay-gradient">
                                                    <div>
                                                        <video height="280" controlsList="nodownload"  id="profilevideo" >
                                                            <source :src="profileVideo">
                                                        </video>
                                                    </div>
                                                    <div class="card-img-overlay ">
                                                        <div class="row mb-3 ml-0 mr-0 p-lg-3 p-md-3 p-2 black_overlay1" >
                                                            <div class="ml-0 d-flex ">
                                                                <img src="../assets/VideoProfile.svg" class="img-fluid vdimage" alt="videoprofile"/>
                                                                <div class="d-flex flex-column">
                                                                    <span class="fontsize14 proximanova-semibold white ml-2 mr-2 bold14px_white">Video Profile</span>
                                                                    <span class="ml-2 mr-2 fontsize14 proximanova-semibold white bold14px_white">{{savedProfileVideoDate | moment("ll") }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mt-3">
                                                            <img src="../assets/play_video.svg" v-if="!playingPorfileVideo" id="playvideobtn" alt="playvideo" @click="playPorfileVideo">
                                                            <img src="../assets/Pausevideo.svg" class="pausebtn" v-if="playingPorfileVideo" alt="pausevideo" @click="playPorfileVideo">
                                                        </div>
                                                        <div id="bottom">                                                
                                                            <div class="row d-flex ml-0 mr-0 justify-content-between p-lg-3 p-md-3 p-2 pr-0 black_overlay2" >
                                                                <div class="d-flex flex-column  mb-2  justify-content-between">                                                                    
                                                                    <div class="row mt-2 ml-0 d-flex ml-2"  >
                                                                        <div  v-for="(item1,index1) in followers" :key="index1">
                                                                            <div v-show="index1 < 5" class="">
                                                                                <img v-if="!item1.profilePictureLink" alt="profilepic" id="followImage" class="img-fluid rounded-circle" src="../assets/Group2.svg" />
                                                                                <img v-else :src="item1.profilePictureLink" alt="profilepic" class="img-fluid rounded-circle" id="followImage">
                                                                            </div>
                                                                        </div>
                                                                    </div>   
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="col-lg-4 col-md-6 col-6 p-0 " v-if="resumeVideoId !== null">
                                                <div class="card ml-2 mr-2 mb-2 overlay-gradient">
                                                    <div>
                                                        <video height="280" controlsList="nodownload"  id="resumevideo" >
                                                            <source :src="resumeVideo">
                                                        </video>
                                                    </div>
                                                    <div class="card-img-overlay ">
                                                        <div class="row mb-3 ml-0 mr-0 p-lg-3 p-md-3 p-2 black_overlay1" >
                                                            <div class="ml-0 d-flex ">
                                                                <img src="../assets/VideoProfile.svg" class="img-fluid vdimage" alt="videoprofile"/>
                                                                <div class="d-flex flex-column">
                                                                    <span class="fontsize14 proximanova-semibold white ml-2 mr-2 bold14px_white">Video Profile</span>
                                                                    <span class="ml-2 mr-2 fontsize14 proximanova-semibold white bold14px_white">{{savedProfileVideoDate | moment("ll") }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mt-3">
                                                            <img src="../assets/play_video.svg" v-if="!playingResumeVideo" id="playvideobtn" alt="playvideo" @click="playResumeVideo">
                                                            <img src="../assets/Pausevideo.svg" class="pausebtn" v-if="playingResumeVideo" alt="pausevideo" @click="playResumeVideo">
                                                        </div>
                                                        <div id="bottom">                                                
                                                            <div class="row d-flex ml-0 mr-0 justify-content-between p-lg-3 p-md-3 p-2 pr-0 black_overlay2" >
                                                                <div class="d-flex flex-column  mb-2  justify-content-between">                                                                    
                                                                    <div class="row mt-2 ml-0 d-flex ml-2"  >
                                                                        <div  v-for="(item1,index1) in followers" :key="index1">
                                                                            <div v-show="index1 < 5" class="">
                                                                                <img v-if="!item1.profilePictureLink"  id="followImage" alt="profilepic" class="img-fluid rounded-circle" src="../assets/Group2.svg" />
                                                                                <img v-else :src="item1.profilePictureLink"  class="img-fluid rounded-circle" alt="profilepic" id="followImage">
                                                                            </div>
                                                                        </div>
                                                                    </div>   
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-3 pb-3" >
                                        <hr class="profhoriz">
                                    </div>
                                    <div>
                                        <span class="fontsize32  proximanova">You will lose some of the worlds great companies are looking into your profile </span>
                                        <div class="mt-3 d-flex flex-wrap justify-content-between mb-4">
                                            <div class="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-between p-0 ">
                                                <div class="d-flex">
                                                    <div class="d-flex">
                                                        <div class="dot"></div>
                                                        <div class=" mr-2 text-center">
                                                            <img src="../assets/VideoProfile.svg" width="45px" class="img-fluid border border-dark borderradiushalf rounded-circle" alt="videoprofile">
                                                        </div>
                                                    </div>
                                                    <div class="d-flex flex-column mt-2">
                                                        <span class="fontsize20 black proximanova" >Apple</span>
                                                        <span class="fontsize16 black60 proximanova">Looking for Product designer</span>
                                                    </div>
                                                </div>                                        
                                            </div>
                                            <div class="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-between  p-0 ">
                                                <div class="d-flex">
                                                    <div class="d-flex">
                                                        <div class="dot"></div>
                                                        <div class=" mr-2 text-center">
                                                            <img src="../assets/VideoProfile.svg" width="45px" class="img-fluid border border-dark borderradiushalf rounded-circle" alt="videoprofile">
                                                        </div>
                                                    </div>
                                                    <div class="d-flex flex-column mt-2">
                                                        <span class="fontsize20 black proximanova" >Samsung</span>
                                                        <span class="fontsize16 black60 proximanova">Looking for Product designer</span>
                                                    </div>
                                                </div>                                        
                                            </div>
                                            <div class="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-between  p-0 ">
                                                <div class="d-flex">
                                                    <div class="d-flex">
                                                        <div class="dot"></div>
                                                        <div class=" mr-2 text-center">
                                                            <img src="../assets/VideoProfile.svg" width="45px" class="img-fluid border border-dark borderradiushalf rounded-circle" alt="videoprofile">
                                                        </div>
                                                    </div>
                                                    <div class="d-flex flex-column mt-2">
                                                        <span class="fontsize20 black proximanova" >Amazon</span>
                                                        <span class="fontsize16 black60 proximanova">Looking for Product designer</span>
                                                    </div>
                                                </div>                                        
                                            </div>
                                            <div class="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-between p-0  ">
                                                <div class="d-flex">
                                                    <div class="d-flex">                                                        
                                                        <div class=" mr-2 text-center">
                                                            <img src="../assets/VideoProfile.svg" width="45px" class="img-fluid border border-dark borderradiushalf rounded-circle" alt="videoprofile">
                                                        </div>
                                                    </div>
                                                    <div class="d-flex flex-column mt-2">
                                                        <span class="fontsize20 black proximanova" >Facebook</span>
                                                        <span class="fontsize16 black60 proximanova">Looking for Sr UI designer</span>
                                                    </div>
                                                </div>                                        
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="followers.length > 0" class="pt-4">
                                        <span class="fontsize32  proximanova">You will also lose all the people who are following you like… </span>
                                        <div class="mt-3 d-flex flex-wrap justify-content-between">
                                            <div class="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-between  p-0 " v-for="(user,index) in followers" :key="index">
                                                    <div v-if="index < 4">
                                                        <div class="d-flex">
                                                            <div class="d-flex">                                                                
                                                                <div class=" mr-2 text-center">
                                                                    <img :src="user.profilePictureLink" v-if="user.profilePictureLink" id="followImg" width="45px" height="45px" class="img-fluid border border-dark borderradiushalf rounded-circle followImg" alt="profilepic">
                                                                    <img v-else src="../assets/Profile_placehlder.svg" id="followImg" width="45px" height="45px" class="img-fluid border border-dark borderradiushalf rounded-circle followImg" alt="profilepic">
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-column mt-2">
                                                                <span class="fontsize20 black proximanova" >{{user.userFirstName}}</span>
                                                                <span class="fontsize16 black60 proximanova">{{user.userRole}}</span>
                                                            </div>
                                                        </div>       
                                                    </div>                                 
                                                </div>
                                        </div>
                                    </div>
                                    <div class="pt-3 pb-3">
                                        <hr class="profhoriz">
                                    </div>
                                    <div class="">
                                        <div class="fontsize32 proximanova-semibold">Are you experience a certain problem with Worknotion account?</div>
                                        <div class="fontsize32 proximanova-semibold mb-2">We are here to help.</div>
                                        <div v-for="(reason, index) in reasons" :key="index">
                                            <div class="d-flex " >
                                                <input type="checkbox" :id="'reason'+index" @click="boxChecked(index)" name="reportvideoprofile" :value="index" class="mt-2" >
                                                <div class="d-flex flex-column">
                                                    <label :for="'reason'+reason.id" class="proximanova fontsize20 black ml-2" >{{reason.reason}}</label>  
                                                </div>
                                                <br>
                                                
                                            </div>
                                            <div v-if="reason.showTextArea" class="ml-4">
                                                <div class="fontsize16 proximanova black ">Please let us know what is the issue:</div>
                                                <div class=" pb-3 col-lg-6 col-md-8 col-12 p-0" v-if="reason.showTextArea" >
                                                    <textarea
                                                        class="form-control"                                            
                                                        id="exampleFormControlTextarea1"  
                                                        v-model="reason.text"                  
                                                        rows="5"
                                                        cols="70"                                            
                                                        spellcheck="true"
                                                        maxlength="400"
                                                        placeholder=""
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div class="pt-3 pb-3">
                                        <hr class="profhoriz">
                                    </div>
                                    <div >
                                        <div class="fontsize32  proximanova-semibold black text-capitalize">Your feedback matters.</div>
                                        <div class="fontsize16 proximanova black mb-2">Is there anything else you’d like us to know?</div>
                                    </div>
                                    <div class="mt-lg-4 pb-3 col-lg-6 col-md-8 col-12 p-0">
                                        <textarea
                                            class="form-control"                                            
                                            id="exampleFormControlTextarea1"                    
                                            rows="5"
                                            cols="70"                                            
                                            spellcheck="true"
                                            maxlength="400"
                                            placeholder=""
                                        ></textarea>
                                    </div>
                                </div>                                
                            </section>
                            <div class="section2">
                                <div class="d-flex justify-content-center p-3">
                                    <div  class="btn button-create btn-color mr-2 "  id="search">
                                        <span class="proximanova-semibold fontsize14 black80">Back</span>
                                    </div>
                                    <div   class="btn button-create backgroundcolorblack borderradius20 white" id="search"  data-toggle="modal" data-target="#deleteExpModal">
                                        <span class="proximanova-semibold fontsize16 white">Close Account</span>
                                    </div>                                    
                                </div>
                                
                            </div>
                            <div class="modal fade" id="deleteExpModal" tabindex="-1" role="dialog" aria-labelledby="deleteExpModalLabel" aria-hidden="true">
                                <div class="modal-dialog modalBody" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header delete-modal">
                                            <h5 class="modal-title proximanova fontsize24" id="deleteExpModalLabel">Are you sure to Close your Account?</h5>
                                            <button type="button" class="close borderradius20" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>                                           
                                        </div>
                                        
                                        <div class="modal-body modal-delete text-center p-3">
                                            <div class="text-center proximanova fontsize16 black">If you Close your Account now, you’ll lose all info with Worknotion.Think Twice to Close Account.</div>
                                            <div class="pt-4">
                                                <span class="button-cancel-font modaldeletebtn border borderradius20 p-2 pr-4 pl-4" data-dismiss="modal" aria-label="Close" >No</span>
                                                <span class="button-cancel-font backgroundcolorblack white border p-2 ml-2 pr-4 pl-4 borderradius20" >Yes</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
export default{
    data(){
        return{
            profilePicLink:'',
            firstname: "",
            lastname: "",
            profileVideo: '',
            resumeVideo:'',
            savedProfileVideoDate : null,
            playingPorfileVideo: false,
            playingResumeVideo: false,
            profileVideoId: null,
            resumeVideoId: null,
            resultCount: 0,
            profileId: null,
            followers: [],     
            pageLoder: true,       
            reasons: [
                {reason:'Problem with Logging in.',
                showTextArea : false,
                text : ''},
                {reason:'Seach for people, jobs, Videos, Products.',
                showTextArea : false,
                text : ''},
                {reason:'Privacy Policy and Security.',
                showTextArea : false,
                text : ''},
                {reason:'Website and mobile app usage issue.',
                showTextArea : false,
                text : ''},
                {reason:'Video profile and video resume creation.',
                showTextArea : false,
                text : ''},
                {reason:'Video creation issue.',
                showTextArea : false,
                text : ''},
                {reason:'Home page and News feed.',
                showTextArea : false,
                text : ''},
                {reason:'Others.',
                showTextArea : false,
                text : ''}]
        }
    },
    mounted() {
    //set page scroll
    window.scrollTo(0, 0);
    this.getUserByID();    
    },
    methods:{
        getUserByID() {      
        httpuserprofile
            .get("/userprofile/userbyid/" + sessionUtils.getUserId())
            .then(response => {console.log(response)
            
            this.profileId = response.data.profileId;
                this.profilePicLink = response.data.profilePictureLink;
                this.firstname = response.data.firstName;
                this.lastname = response.data.lastName;                
                if(response.data.resumeVideoId !== null) {  
                this.resumeVideoId = response.data.resumeVideoId;
                this.resumeVideo = response.data.resumeVideoDetails.videoLink;
                }
                if(response.data.profileVideoId !== null) {  
                    this.profileVideoId = response.data.profileVideoId;
                    this.profileVideo = response.data.profileVideoDetails.videoLink;                  
                    if(response.data.profileVideoDetails.creationD !== null){
                    this.savedProfileVideoDate = response.data.profileVideoDetails.creationD
                    }
                    if(response.data.profileVideoDetails.lastUpdatedD !== null) {
                    this.savedProfileVideoDate = response.data.profileVideoDetails.lastUpdatedD
                    }
                    
                                      
                }
                this.pageLoder = false;
                this.getFollowersList(); 
            }).catch((e) => {
        console.log(e)
      });
        },
        boxChecked(ind){
            var id='reason'+ind;            
            var checkBox = document.getElementById(id);            
            if (checkBox.checked == true){
               this.reasons[ind].showTextArea = true;              
            } else {
               this.reasons[ind].showTextArea = false;  
            }
            console.log(this.reasons[ind])
        },
        playResumeVideo : function() {
        var video = document.getElementById('resumevideo')
        var profileVideo = document.getElementById('profilevideo')
        this.playingPorfileVideo = false;
        if(!this.playingResumeVideo) {
            this.playingResumeVideo = true
            video.play()
            if(profileVideo) {
            profileVideo.pause()
            }
        }else{
            this.playingResumeVideo = false;
            video.pause()
        }
        },
        playPorfileVideo() {
        var video = document.getElementById('profilevideo')
        var ResumeVideo = document.getElementById('resumevideo')
        console.log(video)
        console.log(ResumeVideo)
        this.playingResumeVideo = false;
        if(!this.playingPorfileVideo) {
            this.playingPorfileVideo = true
            video.play()
            if(ResumeVideo) {
            ResumeVideo.pause()
            }
        }else{
            this.playingPorfileVideo = false;
            video.pause()
        }
        },
        getFollowersList(){
        httpuserprofile
        .get("/userprofile/getFollowerUserList?profileId="+this.profileId+'&loginUserProfileId='+this.profileId+'&loginUserType=user&limit=10&offset=0')
        .then(response => {         
            if(response.data){                
                this.resultCount = response.data.length;                 
                this.followers = response.data;     
                console.log(this.followers)                   
            }          
        });
    }, 
    }

}
</script>
<style scoped>

.main-card {
    padding-left: 2% !important;
    padding-right: 2% !important;
  }
.section1{
    color:white;
    background-size: cover;
    -webkit-background-size: cover;
    overflow: hidden;
}
#profImage{
    width: 72px;
    height: 72px;
}
.section2{
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: white;
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.modalBody{
    max-width: 600px !important;
}
.black_overlay1 {
  background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
  border-radius: 4px 4px 5px 4px;
  padding-bottom: 10px;
}
.videoheadsection {
  padding-left: 8px !important;
  padding-right: 0px !important;
}
#followImg{
    width: 45px;
    height: 45px;
}
.form-control{
    background-color: #F0F2F5;
    border: 1px solid rgba(31, 31, 31,0.3);
}

.form-control:focus{
  outline: none !important;
    box-shadow: none !important;    
     background-color: #F0F2F5;
     border: 1px solid rgba(31, 31, 31,0.3);
}
#profilevideo{
  width: 100%;
  border-radius: 4%;
  object-fit: fill;
}
.modaldeletebtn{
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modaldeletebtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.modaldeletebtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.modal-height{
  height: 550px;
  width: 100% !important;
  border-radius: 10px !important;
  
}
.modal-header{
    border-bottom: none;
}
.border-tab-bottom{
    border-bottom-style: solid;
    border-bottom-color: #0078FF;
  }
.modal-body{
  background-color: #000000
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  /* margin-left: 3px; */
  margin-right: 10px;
  border-radius: 8px;
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
#deleteExpModal{
  margin-top: 15%;
  padding-right: 0px !important;
}
#resumevideo {
  width: 100%;
  border-radius: 4%;
}
.card-img-overlay {
  padding: 0 !important;
}
#playvideobtn {
  /* display: none; */
  margin-left: 45%;
  margin-top: 11%;
  cursor: pointer;
}
.pausebtn{
  display: none;
}
.card-img-overlay:hover  .pausebtn{
  display: block;
  margin-left: 45%;
  margin-top: 15%;
  cursor: pointer;
}
.btn-color{
    border: 1px solid black;
}
.black_overlay2 {
  background: linear-gradient(180deg, rgba(0,0,0,0) 10%, #000000 100%);
  border-radius: 0 4px 5px 4px;
}
#bottom {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
#followImage{
  width: 30px;
  height: 30px;
  transform: scale(1.2)  !important;
  border: 1px solid #1F1F1F;
}
@media only screen and (max-width: 600px) {
    #followImage{
    width: 25px;
    height: 25px;
}
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
}
@media only screen and (max-width: 400px) {
    #followImage{
    width: 20px;
    height: 20px;
}
 
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
